import { Controller } from 'stimulus';
var moment = require('moment');
export default class CartController extends Controller {

  connect() {
    this.element[this.identifier] = this
    this.refresh()
  }

  toggle() {
    $('.loading_app_container').removeClass('d-none')
    $.get('/cart/reload')
  }

  refresh() {
    $.get('/cart/load')
  }
}
